import { NgModule, ModuleWithProviders } from '@angular/core'
import { IcosMessageService } from './message/message.service'
import { IcosNotificationService } from './notification/notification.service'

import { IcosSharedModule } from './shared/module'
import { IcosButtonsModule } from './button/module'
import { IcosCheckboxsModule } from './checkbox/module'
import { IcosIconsModule } from './icon/module'
import { IcosRadiosModule } from './radio/module'
import { IcosMenusModule } from './menu/module'
import { IcosTooltipModule } from './tooltip/module'
import { IcosRowModule } from './row/module'
import { IcosColModule } from './col/module'
import { IcosInputsModule } from './input/module'
import { IcosInputNumberModule } from './input-number/module'
import { IcosTagsModule } from './tag/module'
import { IcosSelectModule } from './select/module'
import { IcosSwitchModule } from './switch/module'
import { IcosRateModule } from './rate/module'
import { IcosProgressModule } from './progress/module'
import { IcosStepsModule } from './steps/module'
import { IcosLoadingModule } from './loading/module'
import { IcosMessagesModule } from './message/module'
import { IcosNotificationModule } from './notification/module'
import { IcosCascaderModule } from './cascader/module'
import { IcosBadgesModule } from './badge/module'
import { IcosCardsModule } from './card/module'
import { IcosDropdownModule } from './dropdown/module'
import { IcosBreadcrumbsModule } from './breadcrumb/module'
import { IcosDateModule } from './date-picker/module'
import { IcosSliderModule } from './slider/module'
import { IcosDialogModule } from './dialog/module'
// import { IcosCarouselModule } from './carousel/module'
import { IcosCollapseModule } from './collapse/module'
import { IcosAlertModule } from './alert/module'
import { IcosPaginationModule } from './pagination/module'
import { IcosUploadModule } from './upload/module'
import { IcosTableModule } from './table/module'
import { IcosContainerModule } from './container/module'
import { IcosFormModule } from './form/module'
import { IcosTreeModule } from './tree/module'
import { UserSafeHooks } from './tree/tree'
export const ICOSChildModules: any = {
  IcosButtonsModule,
  IcosIconsModule,
  IcosRadiosModule,
  IcosMenusModule,
  IcosTooltipModule,
  IcosRowModule,
  IcosColModule,
  IcosCheckboxsModule,
  IcosInputsModule,
  IcosInputNumberModule,
  IcosTagsModule,
  IcosSelectModule,
  IcosSwitchModule,
  IcosRateModule,
  IcosProgressModule,
  IcosStepsModule,
  IcosLoadingModule,
  IcosMessagesModule,
  IcosSharedModule,
  IcosNotificationModule,
  IcosCascaderModule,
  IcosBadgesModule,
  IcosCardsModule,
  IcosDropdownModule,
  IcosBreadcrumbsModule,
  IcosDateModule,
  IcosSliderModule,
  IcosDialogModule,
  /*IcosCarouselModule,*/ IcosCollapseModule,
  IcosAlertModule,
  IcosPaginationModule,
  IcosUploadModule,
  IcosTableModule,
  IcosContainerModule,
  IcosFormModule,
  IcosTreeModule
}
export const ICOSMODULES_GROUP: any[] = [
  IcosButtonsModule,
  IcosIconsModule,
  IcosRadiosModule,
  IcosMenusModule,
  IcosTooltipModule,
  IcosRowModule,
  IcosColModule,
  IcosCheckboxsModule,
  IcosInputsModule,
  IcosInputNumberModule,
  IcosTagsModule,
  IcosSelectModule,
  IcosSwitchModule,
  IcosRateModule,
  IcosProgressModule,
  IcosStepsModule,
  IcosLoadingModule,
  IcosMessagesModule,
  IcosSharedModule,
  IcosNotificationModule,
  IcosCascaderModule,
  IcosBadgesModule,
  IcosCardsModule,
  IcosDropdownModule,
  IcosBreadcrumbsModule,
  IcosDateModule,
  IcosSliderModule,
  IcosDialogModule,
  /*IcosCarouselModule,*/ IcosCollapseModule,
  IcosAlertModule,
  IcosPaginationModule,
  IcosUploadModule,
  IcosTableModule,
  IcosContainerModule,
  IcosFormModule,
  IcosTreeModule
]

@NgModule({
  imports: [
    IcosButtonsModule.forRoot(),
    IcosIconsModule.forRoot(),
    IcosRadiosModule.forRoot(),
    IcosMenusModule.forRoot(),
    IcosTooltipModule.forRoot(),
    IcosRowModule.forRoot(),
    IcosColModule.forRoot(),
    IcosCheckboxsModule.forRoot(),
    IcosInputsModule.forRoot(),
    IcosInputNumberModule.forRoot(),
    IcosTagsModule.forRoot(),
    IcosSelectModule.forRoot(),
    IcosSwitchModule.forRoot(),
    IcosRateModule.forRoot(),
    IcosProgressModule.forRoot(),
    IcosStepsModule.forRoot(),
    IcosLoadingModule.forRoot(),
    IcosMessagesModule.forRoot(),
    IcosSharedModule.forRoot(),
    IcosNotificationModule.forRoot(),
    IcosCascaderModule.forRoot(),
    IcosBadgesModule.forRoot(),
    IcosCardsModule.forRoot(),
    IcosDropdownModule.forRoot(),
    IcosBreadcrumbsModule.forRoot(),
    IcosDateModule.forRoot(),
    IcosSliderModule.forRoot(),
    IcosDialogModule.forRoot(),
    /*IcosCarouselModule.forRoot(),*/ IcosCollapseModule.forRoot(),
    IcosAlertModule.forRoot(),
    IcosPaginationModule.forRoot(),
    IcosUploadModule.forRoot(),
    IcosTableModule.forRoot(),
    IcosContainerModule.forRoot(),
    IcosFormModule.forRoot(),
    IcosTreeModule.forRoot()
  ],
  exports: ICOSMODULES_GROUP
})
class IcosModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: IcosModule,
      providers: []
    }
  }
}

export { IcosModule, IcosMessageService, IcosNotificationService, UserSafeHooks }
